import { APP_ECONTRACT, SYSTEM_APP_ECONTRACT, SYSTEM_APP_SIGN, TEST_SYSTEM } from 'constants/global';

const getSystem = () => {
    const host = window.location.hostname;

    if (['127.0.0.1', 'localhost'].includes(host)) {
        return TEST_SYSTEM;
    }

    return host.includes(APP_ECONTRACT) ? SYSTEM_APP_ECONTRACT : SYSTEM_APP_SIGN;
};

export default getSystem;
